__turbopack_context__.v({
  "className": "anton_ab12457f-module__D3H-YW__className",
});
